import { GridCellProps } from "@progress/kendo-react-grid";

export const IndicateurCell = (props: GridCellProps) => {
  let text = "";

  if (props.dataItem.mag_selected && props.dataItem.field_highlight)
    text = "∗ >";
  else if (props.dataItem.mag_selected) text = ">";
  else if (props.dataItem.field_highlight) text = "∗";

  return (
    <td
      colSpan={1}
      className="k-table-td"
      role="gridcell"
      aria-colindex={1}
      aria-selected="false"
      style={{ paddingBlock: "4px", paddingInline: "6px" }}
      data-grid-col-index="0"
      ref={(node) => {
        if (node && text) {
          node.style.setProperty(
            "background-color",
            props.dataItem.field_highlight ? "yellow" : "#0257d5",
            "important"
          );
          node.style.setProperty(
            "color",
            props.dataItem.field_highlight ? "black" : "white",
            "important"
          );
        }
      }}
    >
      <span style={{ fontWeight: "bold" }}>{text}</span>
    </td>
  );
};